import StyledTableHead from 'Components/StyledTableHead'
import type { NetaxeptPaymentEventShape } from 'Services/SalesManagement/Features/Order/orderSlice'
import { datetimeFormatter, showValueOrHyphen } from 'Util/formatters'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import type { FC } from 'react'
import { t } from 'ttag'

const NetaxeptPaymentEvents: FC<{
  events: NetaxeptPaymentEventShape[]
}> = ({ events }) => {
  return (
    <>
      {events.map(event => (
        <TableRow key={`${event.transaction_id}-${event.created}`}>
          <TableCell>{datetimeFormatter(event.created)}</TableCell>
          <TableCell>{showValueOrHyphen(event.transaction_id)}</TableCell>
        </TableRow>
      ))}
    </>
  )
}

const NetaxeptPaymentInfo: FC<{
  events: NetaxeptPaymentEventShape[]
}> = ({ events }) => {
  return (
    <>
      <StyledTableHead>
        <TableRow>
          <TableCell colSpan={3}>{t`Payment info (Netaxept)`}</TableCell>
        </TableRow>
      </StyledTableHead>
      <TableHead>
        <TableRow>
          <TableCell>{t`Created`}</TableCell>
          <TableCell>{t`Transaction ID`}</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {events.length > 0 ? (
          <NetaxeptPaymentEvents events={events} />
        ) : (
          <TableRow>
            <TableCell>{t`No payment events available`}</TableCell>
          </TableRow>
        )}
      </TableBody>
    </>
  )
}

export { NetaxeptPaymentInfo }
